import { USER_ROLES } from './index';
import { PORTAL_ACCENT } from '../styles/portalTheme';

/** Backend `data.type` values for portal vetting notifications. */
export const VETTING_NOTIFICATION_TYPE = {
  VETTING_DECISION_FINALIZED: 'vetting_decision_finalized',
  VETTING_MANUAL_REVIEW_REQUIRED: 'vetting_manual_review_required',
  VETTING_SCORING_FAILED: 'vetting_scoring_failed',
};

export const VETTING_APPLICATION_TARGET_TYPE = 'vetting_application';

export const VETTING_NOTIFICATION_CATALOG = {
  [VETTING_NOTIFICATION_TYPE.VETTING_DECISION_FINALIZED]: {
    recipientRole: USER_ROLES.ADMIN,
    actorRole: null,
    label: 'New vetted user',
    accentColor: PORTAL_ACCENT,
    defaultMessage: 'A vetting application decision has been finalized',
  },
  [VETTING_NOTIFICATION_TYPE.VETTING_MANUAL_REVIEW_REQUIRED]: {
    recipientRole: USER_ROLES.ADMIN,
    actorRole: null,
    label: 'New vetted user decision required',
    accentColor: PORTAL_ACCENT,
    defaultMessage: 'A vetting application needs manual review',
  },
  [VETTING_NOTIFICATION_TYPE.VETTING_SCORING_FAILED]: {
    recipientRole: USER_ROLES.ADMIN,
    actorRole: null,
    label: 'New vetted user score failed : Please rescore it',
    accentColor: PORTAL_ACCENT,
    defaultMessage: 'Vetting scoring failed and the application needs to be rescored',
  },
};

const normalizeTypeKey = (type) =>
  String(type || '')
    .trim()
    .toLowerCase();

export const getVettingNotificationMeta = (type) => {
  const key = normalizeTypeKey(type);
  return VETTING_NOTIFICATION_CATALOG[key] ?? null;
};

export const isVettingNotificationForRole = (type, userRole) => {
  const key = normalizeTypeKey(type);
  const meta = getVettingNotificationMeta(key);
  if (meta) {
    return meta.recipientRole === userRole;
  }
  if (key === VETTING_APPLICATION_TARGET_TYPE) {
    return userRole === USER_ROLES.ADMIN;
  }
  return false;
};

export const pickVettingApplicationId = (source = {}) => {
  const nested = source.data ?? {};
  const targetType = String(source.targetType ?? nested.targetType ?? '')
    .trim()
    .toLowerCase();
  const targetId = source.targetId ?? nested.targetId ?? null;

  if (targetId && String(targetId).trim()) {
    if (!targetType || targetType === VETTING_APPLICATION_TARGET_TYPE) {
      return String(targetId).trim();
    }
  }

  return null;
};

/**
 * Deep link for push click / inbox row.
 * @param {object} params
 * @param {string} [params.type]
 * @param {string} [params.applicationId]
 * @param {string} params.viewerRole
 */
export const resolveVettingNotificationPath = ({ type, applicationId, viewerRole }) => {
  const isAdmin = viewerRole === USER_ROLES.ADMIN;
  const id = applicationId ? String(applicationId).trim() : null;
  const normalizedType = normalizeTypeKey(type);

  if (!isAdmin) {
    return '/partner-notifications';
  }

  if (!id) {
    return '/notifications';
  }

  switch (normalizedType) {
    case VETTING_NOTIFICATION_TYPE.VETTING_DECISION_FINALIZED:
    case VETTING_NOTIFICATION_TYPE.VETTING_MANUAL_REVIEW_REQUIRED:
    case VETTING_NOTIFICATION_TYPE.VETTING_SCORING_FAILED:
      return `/vetted-users/${id}`;
    default:
      return `/vetted-users/${id}`;
  }
};
